import Vue from 'vue'
import LDUF from 'lodash.upperfirst'
import LDCC from 'lodash.camelcase'

const createComponentName = (name) => {
  return `SVG${LDUF(LDCC(name.replace(/\/(.*)\//, '').replace(/\.\w+$/, '')))}`
}

const requireFromContext = (requireContext) => {
  requireContext.keys().forEach((fileName) => {
    const componentConfig = requireContext(fileName)
    const componentName = createComponentName(fileName)
    Vue.component(componentName, componentConfig.default || componentConfig)
  })
}

// Import base DR SVGs
const baseSVGContext = require.context('@mannum/dr-components/dist/svg', true, /[\w-]+\.svg$/)
requireFromContext(baseSVGContext)

// Import app specific SVGs
const appSVGContext = require.context('.', true, /[\w-]+\.svg$/)
requireFromContext(appSVGContext)
